import script from "./OrderStatusPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderStatusPage.vue?vue&type=script&setup=true&lang=ts"

import "./OrderStatusPage.vue?vue&type=style&index=0&id=a03dcd7a&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a03dcd7a"]])

export default __exports__